import API from '../../app/services/API';

const api = new API();

export const getProjectSimulator = async () => {
  return api.getProjectSimulator();
};

export const postProjectSimulator = async () => {
  return api.postProjectSimulator();
};

export const patchProjectSimulator = async (form) => {
  return api.patchProjectSimulator(form);
};

export const postProjectFromSimulator = async ({ name, companyId }) => {
  return api.postProjectFromSimulator({ name, companyId });
};
